import { getFullLocale } from './get-full-locale';
import { getPartLocale } from './get-part-locale';
export var getLocale = function (params) {
    var isFromCookie = params && params.isFromCookie;
    var fullLocale = getFullLocale(isFromCookie);
    var partLocale = getPartLocale(fullLocale);
    return params && params.isFull ? fullLocale : partLocale;
};
